/**
 * The verses the player will recite: from the first row visible in the
 * reading area to the end of that row's page (legacy audioOpen queue). With
 * `fromSurah`, it starts at the first verse after the surah band on screen.
 * The blurred taste of the next page is on screen too, but belongs to another
 * page, so the page filter leaves it out.
 */
export function recitationQueue(scroll: HTMLElement, pageOf: (id: string) => number | undefined, fromSurah: boolean): string[] {
  const rows = Array.from(scroll.querySelectorAll<HTMLElement>('.vrow[data-id]'));
  const top = scroll.getBoundingClientRect().top;
  let startIdx = rows.findIndex((r) => r.getBoundingClientRect().bottom > top + 4);
  if (startIdx < 0) startIdx = 0;
  if (fromSurah) {
    const sr = scroll.getBoundingClientRect();
    const vis = Array.from(scroll.querySelectorAll('.sband')).filter((b) => { const r = b.getBoundingClientRect(); return r.bottom > sr.top && r.top < sr.bottom; }).pop();
    if (vis) {
      let n = vis.nextElementSibling;
      while (n && !n.classList.contains('vrow')) n = n.nextElementSibling;
      if (n) { const i = rows.indexOf(n as HTMLElement); if (i >= 0) startIdx = i; }
    }
  }
  const startPage = rows[startIdx] ? pageOf(rows[startIdx].dataset.id!) ?? null : null;
  return rows.slice(startIdx).filter((r) => !startPage || pageOf(r.dataset.id!) === startPage).map((r) => r.dataset.id!);
}

/** True when a surah band is in the upper two thirds of the reading area (legacy audioStart). */
export function surahBeginsOnScreen(scroll: HTMLElement): boolean {
  const sr = scroll.getBoundingClientRect();
  return Array.from(scroll.querySelectorAll('.sband')).some((b) => { const br = b.getBoundingClientRect(); return br.bottom > sr.top + 8 && br.top < sr.top + sr.height * 0.66; });
}
